<template>
  <v-bottom-navigation
    fixed
    scroll-target="#scroll-threshold-example"
    scroll-threshold="500"
    height="96"
  >
    <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
      <v-col cols="12" class="py-0 pl-0 pr-2">
        <v-btn
          block
          elevation="0"
          class="btn-fixed"
          :class="btnColor"
          style="background-color: #465166"
          @click="$emit('clickBtn')"
        >
          <span class="white--text">{{ btnName }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-bottom-navigation>
</template>

<script>
export default {
  props: {
    btnName: String,
    btnColor: {
      type: String,
      default: '',
    },
  },
};
</script>

<style></style>
